export default __webpack_public_path__ + "static/media/SignUp.a8607779.jpg";